export function isMicroInverterType(type) {
  if (!type) return false;
  const t = String(type).trim().toLowerCase();
  return t === 'm' || t === 'micro' || t.includes('micro');
}

export function getInverterGroup(inverterOrType) {
  const type =
    inverterOrType && typeof inverterOrType === 'object'
      ? inverterOrType.type
      : inverterOrType;
  return isMicroInverterType(type) ? 'micro' : 'central';
}

export function matchesPrimaryInverterType(primaryInverter, candidateInverter) {
  if (!primaryInverter || !primaryInverter.type) return true;
  if (!candidateInverter) return false;
  return getInverterGroup(primaryInverter) === getInverterGroup(candidateInverter);
}

export const FIXED_INVERTER_PANEL_CAPACITY_MESSAGE =
  'Not all selected panels fit with the current fixed inverter quantities. Increase the inverter quantity or switch it to Auto to keep all panels in the design.';
export const FIXED_INVERTER_PANEL_CAPACITY_CALLBACK = 'Warning';

export function buildFixedInverterPanelCapacityNotification() {
  return {
    code: '61',
    message: FIXED_INVERTER_PANEL_CAPACITY_MESSAGE,
  };
}

export function hasFixedInverterQuantity({
  primaryInverterAutoQuantity = true,
  additionalInverters = [],
} = {}) {
  if (primaryInverterAutoQuantity === false) return true;
  return Array.isArray(additionalInverters)
    ? additionalInverters.some(
        (inverter) =>
          inverter?.autoQuantity === false || inverter?.auto_quantity === false
      )
    : false;
}

export function countSelectedPanelsPerRoof(selectedPanelsPerRoof) {
  if (!selectedPanelsPerRoof || typeof selectedPanelsPerRoof !== 'object') {
    return 0;
  }

  return Object.values(selectedPanelsPerRoof).reduce(
    (total, panels) => total + (Array.isArray(panels) ? panels.length : 0),
    0
  );
}

export function countProductionPayloadPanels(payload) {
  const roofs = Array.isArray(payload?.roofs) ? payload.roofs : [];
  return roofs.reduce(
    (total, roof) => total + Number(roof?.panels?.panel_count || 0),
    0
  );
}

export function sumInverterCounts(invertersUsed = []) {
  if (!Array.isArray(invertersUsed)) return 0;
  return invertersUsed.reduce((total, inverter) => {
    const count = Number(inverter?.count);
    return total + (Number.isFinite(count) && count > 0 ? count : 0);
  }, 0);
}

export function resolveMicroInverterQuantity({
  inverter,
  primaryInverterAutoQuantity = true,
  selectedPanelCount,
  invertersUsed,
  fallbackQuantity = 1,
} = {}) {
  const fallback = Math.max(1, Number(fallbackQuantity) || 1);
  if (!isMicroInverterType(inverter?.type) || primaryInverterAutoQuantity === false) {
    return fallback;
  }

  const selectedCount = Number(selectedPanelCount);
  if (Number.isFinite(selectedCount) && selectedCount > 0) {
    return selectedCount;
  }

  const usedCount = sumInverterCounts(invertersUsed);
  return usedCount > 0 ? usedCount : fallback;
}

export function resolveAppliedPanelCount({
  resultPanelCount,
  selectedPanelsPerRoof,
  fallbackPanelCount = 0,
} = {}) {
  const mappedPanelCount = countSelectedPanelsPerRoof(selectedPanelsPerRoof);
  if (mappedPanelCount > 0) return mappedPanelCount;

  const apiPanelCount = Number(resultPanelCount);
  if (Number.isFinite(apiPanelCount) && apiPanelCount >= 0) {
    return apiPanelCount;
  }

  const fallbackCount = Number(fallbackPanelCount);
  return Number.isFinite(fallbackCount) && fallbackCount >= 0 ? fallbackCount : 0;
}

